/* (ignored) */


//////////////////
// WEBPACK FOOTER
// buffer (ignored)
// module id = 927
// module chunks = 2